(function(){
  var drawer = document.getElementById('c9-cart-drawer');
  if(!drawer || drawer.dataset.c9bReady) return;
  drawer.dataset.c9bReady = '1';
  var panel = drawer.querySelector('.c9b__panel');
  var body = drawer.querySelector('[data-cart-body]');
  var foot = drawer.querySelector('[data-c9b-foot]');
  var CART_URL = drawer.getAttribute('data-cart-url') || '/cart';
  var ALL_URL = drawer.getAttribute('data-all-url') || '/collections/all';
  var ON_CART_PAGE = drawer.getAttribute('data-on-cart') === '1';
  var RULES = (window.C9Rules || {});

  /* ── copy (defaults; the Cart template's "Bag drawer" settings override) ── */
  var T = {
    title_full: 'Your gift is almost ready.',
    title_empty: 'Your bag',
    empty_title: 'Nothing in it yet.',
    empty_text: 'Start with what Karachi sends most.',
    empty_cta: 'Shop bestsellers',
    empty_url: ALL_URL + '?sort_by=best-selling',
    empty_finder: 'Not sure? Try the Gift Finder',
    empty_finder_url: '/pages/gift-finder',
    addons_title: 'Finish the gift',
    addons_note: 'Added to the same delivery',
    foot_note: 'Earliest delivery {date} · choose your slot next.',
    cta: 'Choose delivery time & check out',
    cta_note: 'Next: pick your date and time slot. You pay on Shopify’s secure checkout.',
    when: 'Delivering {date}',
    promise_today: 'order in the next {time} for delivery today',
    promise_tomorrow: 'order now for delivery tomorrow',
    promise_made: 'made to order, earliest delivery {date}',
    /* A next-day bag before 8 AM reuses promise_today, counting down to the
       8 AM cut-off rather than to 11 PM. Give promise_next_day its own value
       here (and a setting on the Cart template) if the wording should differ. */
    promise_next_day: '',
    /* Next-day bag whose earliest is neither today nor literally tomorrow
       (Monday was skipped) — a stock item, so never "made to order". */
    promise_earliest: 'earliest delivery {date}',
    slots_made: 'Delivery {slots}'
  };
  var ADDONS = [];

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
  function fmt(cents){ return 'Rs ' + Math.round(cents / 100).toLocaleString('en-US'); }
  function postJSON(url, data){
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description || j.message || 'Something went wrong.'); return j; }); });
  }
  function getCart(){ return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); }

  /* ── open / close, focus kept inside while open ── */
  var lastFocus = null, closeTimer = null;
  function focusables(){ return Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(el){ return el.offsetParent !== null; }); }
  function openCart(){
    clearTimeout(closeTimer);
    if(drawer.dataset.open === 'true') return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function(){ drawer.dataset.open = 'true'; });
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ var c = drawer.querySelector('.c9b__close'); (c || panel).focus({ preventScroll: true }); }, 60);
    loadConfig();
  }
  function closeCart(){
    if(drawer.dataset.open !== 'true' && drawer.hidden) return;
    drawer.dataset.open = 'false';
    document.body.style.overflow = '';
    closeTimer = setTimeout(function(){ drawer.hidden = true; }, 340);
    if(lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function(e){
    var open = e.target.closest && e.target.closest('[data-open-cart]');
    var close = e.target.closest && e.target.closest('[data-close-cart]');
    if(open && !drawer.contains(open)){
      if(ON_CART_PAGE) return; /* on /cart the link simply reloads the page */
      e.preventDefault(); refresh(); openCart(); return;
    }
    if(close && drawer.contains(close)){ closeCart(); }
  });
  document.addEventListener('keydown', function(e){
    if(drawer.dataset.open !== 'true') return;
    if(e.key === 'Escape'){ closeCart(); return; }
    if(e.key === 'Tab'){
      var f = focusables(); if(!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('c9:cart:open', function(){ refresh(); openCart(); });
  document.addEventListener('cart:updated', function(){ refresh(); });
  document.addEventListener('c9:cart-updated', function(){ refresh(); });

  /* ── lead time → delivery promise (same rules as the cart page) ── */
  var LEADS = {}, EXEMPT = {};
  try {
    var seed = JSON.parse(drawer.querySelector('[data-c9b-leads]').textContent) || {};
    LEADS = seed.leads || {};
    (seed.exempt || []).forEach(function(h){ EXEMPT[h] = true; });
  } catch(_) {}
  function leadFromTags(tags, type){
    if(String(type || '') === 'Greeting Card') return -1;
    var t = (tags || []).map(function(x){ return String(x).toLowerCase(); });
    var l = 1;
    if(t.indexOf('sameday') > -1 || t.indexOf('same-day') > -1) l = 0;
    /* After same-day on purpose — strictest wins, matching rawLeadFor(). */
    if(t.indexOf('lead-nextday') > -1) l = 1;   /* 1 day, and never same-day */
    if(t.indexOf('lead-1d') > -1) l = 2;
    if(t.indexOf('lead-5d') > -1) l = 5;
    return l;
  }
  function exemptFromTags(tags){ return FUL ? FUL.isMorningExempt(tags || []) : false; }
  /* BULK RULE — mirrors sections/main-cart.liquid: 10+ of one product needs a
     day's notice (3 for acrylic gifting); cakes are exempt. Here it only moves
     the promised date, never the bag's state. */
  var BULKINFO = {}, BULK_QTY = 10, BULK_DAYS = 1, BULK_DAYS_ACRYLIC = 3;
  function bulkClass(p){
    var t = (p.tags || []).map(function(x){ return String(x).toLowerCase(); }), ty = String(p.type || '').toLowerCase(), ti = String(p.title || '').toLowerCase();
    var cake = ty.indexOf('cake') > -1 || t.indexOf('cake') > -1 || t.indexOf('celebration-cake') > -1 || t.indexOf('lead-1d') > -1 || t.indexOf('lead-5d') > -1;
    var acrylic = ti.indexOf('acrylic') > -1 || t.some(function(x){ return x.indexOf('acrylic') > -1; });
    return { cake: cake, acrylic: acrylic };
  }
  /* Resolves to the bulk lead (0 when none). The lead cache is seeded from
     the page, so a line's cake/acrylic class may still be unknown here — only
     lines at or over the threshold are fetched, and only once. */
  function bulkLeadFor(cart){
    var qty = {}, byPid = {};
    (cart.items || []).forEach(function(it){ qty[it.product_id] = (qty[it.product_id] || 0) + it.quantity; byPid[it.product_id] = it.handle; });
    var big = Object.keys(qty).filter(function(pid){ return qty[pid] >= BULK_QTY; });
    if(!big.length) return Promise.resolve(0);
    return Promise.all(big.map(function(pid){
      var h = byPid[pid];
      if(BULKINFO[h]) return Promise.resolve();
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(p){ BULKINFO[h] = bulkClass(p); })
        .catch(function(){ BULKINFO[h] = { cake: true, acrylic: false }; }); /* unknown → do not move the date */
    })).then(function(){
      var lead = 0;
      big.forEach(function(pid){ var info = BULKINFO[byPid[pid]]; if(!info || info.cake) return; lead = Math.max(lead, info.acrylic ? BULK_DAYS_ACRYLIC : BULK_DAYS); });
      return lead;
    });
  }
  /* The bag's earliest date once the bulk rule is applied, or null when it
     does not move the date. */
  function bulkDate(raw, exempt){
    if(!FUL || LAST_BULK <= 0) return null;
    var n = FUL.earliest(raw, { exempt: !!exempt }), b = FUL.earliest(LAST_BULK, { exempt: true, promote: false });
    return b.iso > n.iso ? b : null;
  }
  /* Resolves to { lead, exempt } for one bag line. */
  function infoFor(item){
    if(item.product_type === 'Greeting Card') return Promise.resolve({ lead: -1, exempt: false });
    if(LEADS.hasOwnProperty(item.handle)) return Promise.resolve({ lead: LEADS[item.handle], exempt: !!EXEMPT[item.handle] });
    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(p){
        LEADS[item.handle] = leadFromTags(p.tags, p.type);
        EXEMPT[item.handle] = exemptFromTags(p.tags);
        BULKINFO[item.handle] = bulkClass(p);
        return { lead: LEADS[item.handle], exempt: EXEMPT[item.handle] };
      })
      .catch(function(){ return { lead: 1, exempt: false }; });
  }
  /* All timing comes from window.C9Fulfil (layout/theme.liquid): the same-day
     cut-off, the opt-in morning rule, the closed days and which slots a
     made-to-order bag may pick. Nothing here hard-codes a cut-off. */
  var FUL = window.C9Fulfil;
  function karachiMinutes(){
    if(FUL) return FUL.minutes();
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Karachi', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; });
      return (parseInt(p.hour, 10) % 24) * 60 + parseInt(p.minute, 10);
    } catch(_) { var d = new Date(); return d.getHours() * 60 + d.getMinutes(); }
  }
  /* Takes the RAW lead from the tags; C9Fulfil applies the 8 AM rule and then
     skips Mondays only when the effective lead is still ≥ 1. */
  function earliest(lead, exempt){
    if(FUL) return FUL.earliest(lead, { exempt: !!exempt }).text;
    var d = new Date(); d.setHours(0,0,0,0);
    d.setDate(d.getDate() + lead);
    if(lead > 0){ while(d.getDay() === 1){ d.setDate(d.getDate() + 1); } } /* production closed Mondays */
    return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function hm(mins){
    if(FUL) return FUL.hm(mins);
    return Math.floor(mins / 60) + 'h ' + ('0' + (mins % 60)).slice(-2) + 'm';
  }
  /* raw = the bag's strictest lead straight from the tags (0 same-day,
     1 next-day stock, 2 custom, 5 tiered). Branch on the RAW lead first:
     only lead-1d / lead-5d are genuinely "made to order" — a plain next-day
     box must never be described that way. */
  function promiseText(raw, exempt){
    var b = function(s){ return '<b>' + esc(s) + '</b>'; };
    /* Custom / tiered cakes — always a date. */
    if(raw >= 2) return esc(T.promise_made).replace('{date}', b(earliest(raw, exempt)));

    var eff = FUL ? FUL.effectiveLead(raw, { exempt: !!exempt }) : raw;
    if(eff === 0){
      /* A next-day item the 8 AM rule has pulled into today: count down to
         8 AM, not to 11 PM — after 8 AM it is tomorrow, not tonight. */
      if(raw > 0){
        var mleft = FUL ? FUL.morningLeft() : 0;
        if(mleft > 0) return esc(T.promise_next_day || T.promise_today).replace('{time}', b(hm(mleft)));
        return esc(T.promise_tomorrow);
      }
      /* A genuine same-day bag: counts down to the same-day cut-off (House rules). */
      var m = karachiMinutes();
      var cut = FUL ? FUL.config.cutoff_min : 1380;
      if(m < cut) return esc(T.promise_today).replace('{time}', b(hm(cut - m)));
      return esc(T.promise_tomorrow);
    }

    /* Next-day item, past the 8 AM cut-off (or exempt from it). Usually
       literally tomorrow — but if Monday was skipped it is not, so say the
       date instead of lying. */
    var e = FUL ? FUL.earliest(raw, { exempt: !!exempt }) : null;
    if(e && !e.isTomorrow) return esc(T.promise_earliest).replace('{date}', b(e.text));
    return esc(T.promise_tomorrow);
  }
  /* "Delivery 4 PM–8 PM or 8 PM–12 AM" — shown only for a made-to-order bag,
     so the drawer never promises a window the cart will then refuse. */
  function slotsNote(raw){
    if(!FUL) return '';
    var state = FUL.stateOfLead(raw);
    if(state !== 'custom' && state !== 'tiered') return '';
    return String(T.slots_made || 'Delivery {slots}').replace('{slots}', FUL.slotsText({ state: state, join: 'or' }));
  }
  var metaSeq = 0;
  function renderMeta(cart){
    var el = drawer.querySelector('[data-c9b-meta]');
    var tl = drawer.querySelector('[data-c9b-title]');
    if(tl) tl.textContent = cart.item_count ? T.title_full : T.title_empty;
    if(!el) return;
    if(!cart.item_count){ el.textContent = T.empty_title; return; }
    var count = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    el.textContent = count;
    var seq = ++metaSeq;
    Promise.all(cart.items.map(infoFor)).then(function(ls){
      if(seq !== metaSeq) return;
      var lead = ls.reduce(function(a, x){ return Math.max(a, x.lead); }, -1);
      /* Strictest item wins, and that includes the exemption: one baked-to-
         order line keeps the WHOLE bag off same-day. */
      var exempt = ls.some(function(x){ return x.lead > 0 && x.exempt; });
      if(lead < 0) return;
      LAST_LEAD = lead;
      LAST_EXEMPT = exempt;
      bulkLeadFor(cart).then(function(bl){
        if(seq !== metaSeq) return;
        LAST_BULK = bl;
        var bd = bulkDate(lead, exempt);
        el.innerHTML = esc(count) + ' · ' + (bd ? esc(T.promise_earliest).replace('{date}', '<b>' + esc(bd.text) + '</b>') : promiseText(lead, exempt));
        renderSlotsNote();
        renderFootnote();
      });
    });
  }
  /* "Earliest delivery Tue 24 Sep · choose your slot next" — computed from the
     bag's strictest line, so a 5-day cake never sits under a same-day promise. */
  function renderFootnote(){
    var fn = drawer.querySelector('[data-c9b-footnote]');
    if(!fn) return;
    if(LAST_LEAD < 0 || !FUL){ fn.textContent = String(T.foot_note || '').replace('{date}', '').replace(/\s+·\s+/, ' · ').trim(); return; }
    var e = bulkDate(LAST_LEAD, LAST_EXEMPT) || FUL.earliest(LAST_LEAD, { exempt: !!LAST_EXEMPT });
    var when = e.isToday ? 'today' : e.isTomorrow ? 'tomorrow' : e.text;
    fn.textContent = String(T.foot_note || '').replace('{date}', when);
  }
  /* The strictest RAW lead in the bag, and whether any line is morning-exempt,
     remembered so a tick can re-render without re-reading every line.
     -1 = not known yet / cards only. */
  var LAST_LEAD = -1, LAST_EXEMPT = false, LAST_BULK = 0;
  function renderSlotsNote(){
    var el = drawer.querySelector('[data-c9b-slots]');
    if(!el) return;
    /* Slot blocking depends on the RAW lead only (custom / tiered), never on
       the morning exemption — a lead-nextday bread still gets all three. */
    var txt = LAST_LEAD < 0 ? '' : slotsNote(LAST_LEAD);
    el.textContent = txt;
    el.hidden = !txt;
  }
  /* Keep the promise honest on a drawer left open: C9Fulfil ticks every 30 s
     and on focus, and the 8 AM flip has to show up here too. */
  document.addEventListener('c9f:tick', function(){
    if(CART && CART.item_count) renderMeta(CART);
  });

  /* ── line rendering ── */
  var MSG_LID = ['Packaging text', 'Box insert'];
  var MSG_CARD = ['Message on card', 'Message', 'Card Message'];
  var SKIP = ['Card for', 'Add-on for', 'Hide Price', 'Recipient Phone'];
  function lineHTML(item, isSub, bundle){
    var p = item.properties || {};
    /* A Build-a-Box bundle: the box line is the parent, titled with the box
       name; its contents and card are children with no stepper; one Remove
       (data-c9b-rm-group) zeroes every line sharing the id. */
    if(bundle && bundle.parent){
      var bsrc = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var bth = bsrc ? '<img src="' + esc(bsrc) + '" alt="" loading="lazy" width="80" height="80">' : '<span class="c9b-ln__ph" aria-hidden="true">c9</span>';
      var bname = esc(p._c9_box_name || item.product_title);
      var n = bundle.count;
      return '<li class="c9b-ln c9b-ln--bundle" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '" data-bundle="' + esc(bundle.id) + '">' +
        '<span class="c9b-ln__th" aria-hidden="true">' + bth + '</span>' +
        '<div class="c9b-ln__main"><span class="c9b-ln__eyebrow">Custom gift box</span><span class="c9b-ln__name">' + bname + '</span>' +
        '<span class="c9b-ln__s">' + n + (n === 1 ? ' item' : ' items') + ' inside</span>' +
        '<button type="button" class="c9b-ln__rm" data-c9b-rm-group="' + esc(bundle.id) + '" aria-label="Remove ' + bname + ' and everything in it">Remove the box</button></div>' +
        '<div class="c9b-ln__side"><span class="c9b-ln__price">' + fmt(bundle.total) + '</span></div></li>';
    }
    if(bundle && bundle.child){
      var cs = '';
      var q = item.quantity > 1 ? esc(item.quantity + '× ') : '';
      var cname = esc(item.product_title);
      MSG_CARD.forEach(function(k){ if(p[k] && !cs){ cs = '<span class="c9b-ln__s c9b-ln__s--msg">Card: “' + esc(p[k]) + '”</span>'; } });
      var meta = [];
      if(p.To) meta.push('To: ' + esc(p.To));
      if(p.From) meta.push('From: ' + esc(p.From));
      if(p.Note) meta.push(esc(p.Note));
      if(meta.length) cs += '<span class="c9b-ln__s c9b-ln__s--mute">' + meta.join(' · ') + '</span>';
      var cprice = item.final_line_price === 0 ? 'Included' : fmt(item.final_line_price);
      return '<li class="c9b-ln c9b-ln--sub c9b-ln--in" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
        '<span class="c9b-ln__th" aria-hidden="true">' + (item.image ? '<img src="' + esc(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" loading="lazy" width="40" height="40">' : '<span class="c9b-ln__ph" aria-hidden="true">c9</span>') + '</span>' +
        '<div class="c9b-ln__main"><span class="c9b-ln__name">' + q + cname + '</span>' + cs + '</div>' +
        '<div class="c9b-ln__side"><span class="c9b-ln__price">' + cprice + '</span></div></li>';
    }
    var occ = p._occasion_image;
    var src = occ || (item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '');
    var th = src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="80" height="80">' : '<span class="c9b-ln__ph" aria-hidden="true">c9</span>';
    var s = '';
    if(item.variant_options && item.variant_options.length && item.variant_options[0] !== 'Default Title') s += '<span class="c9b-ln__s">' + esc(item.variant_options.join(' · ')) + '</span>';
    var used = {};
    MSG_LID.forEach(function(k){ if(p[k] && !used.lid){ used.lid = 1; used[k] = 1; s += '<span class="c9b-ln__s c9b-ln__s--msg">“' + esc(p[k]) + '” on the lid</span>'; } });
    if(p['Cake message']){ used['Cake message'] = 1; s += '<span class="c9b-ln__s c9b-ln__s--msg">“' + esc(p['Cake message']) + '” on the cake</span>'; }
    MSG_CARD.forEach(function(k){ if(p[k] && !used.card){ used.card = 1; used[k] = 1; s += '<span class="c9b-ln__s c9b-ln__s--msg">Card: “' + esc(p[k]) + '”</span>'; } });
    var rest = [];
    Object.keys(p).forEach(function(k){
      if(k.charAt(0) === '_' || !p[k] || used[k] || SKIP.indexOf(k) > -1) return;
      rest.push(esc(k) + ': ' + esc(p[k]));
    });
    if(p['Hide Price']) rest.push('Price hidden on the note');
    if(rest.length) s += '<span class="c9b-ln__s c9b-ln__s--mute">' + rest.join(' · ') + '</span>';
    var price = item.final_line_price === 0 ? 'Complimentary' : fmt(item.final_line_price);
    var name = esc(item.product_title);
    var side = '<div class="c9b-ln__side"><span class="c9b-ln__price">' + price + '</span>' +
      (isSub ? '' : '<div class="c9b-stp"><button type="button" data-c9b-dec="' + esc(item.key) + '"' + (item.quantity <= 1 ? ' disabled' : '') + ' aria-label="One fewer ' + name + '">−</button><span aria-live="polite">' + item.quantity + '</span><button type="button" data-c9b-inc="' + esc(item.key) + '" aria-label="One more ' + name + '">+</button></div>') +
      '</div>';
    return '<li class="c9b-ln' + (isSub ? ' c9b-ln--sub' : '') + '" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
      '<a class="c9b-ln__th" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + th + '</a>' +
      '<div class="c9b-ln__main"><a class="c9b-ln__name" href="' + esc(item.url) + '">' + name + '</a>' + s +
      '<button type="button" class="c9b-ln__rm" data-c9b-rm="' + esc(item.key) + '" aria-label="Remove ' + name + '">Remove</button></div>' +
      side + '</li>';
  }
  /* children follow their parent (linked by _c9_key / _c9_parent); Build-a-Box
     bundles (_c9_box_id) collapse into one parent + its contents. */
  function bundles(items){
    var map = {};
    items.forEach(function(it){
      var id = it.properties && it.properties._c9_box_id;
      if(!id) return;
      var b = map[id] || (map[id] = { id: id, box: null, lines: [], total: 0, count: 0 });
      b.lines.push(it);
      b.total += it.final_line_price || 0;
      if(it.properties._c9_role === 'box') b.box = it;
      else if(it.properties._c9_role === 'content') b.count += it.quantity;
    });
    return map;
  }
  function ordered(items){
    var byKey = {}, out = [], placed = {};
    var B = bundles(items);
    items.forEach(function(it){ var k = it.properties && it.properties._c9_key; if(k) byKey[k] = it; });
    items.forEach(function(it){
      if(placed[it.key]) return;
      var bid = it.properties && it.properties._c9_box_id;
      if(bid && B[bid] && B[bid].box){
        var b = B[bid];
        out.push({ item: b.box, sub: false, bundle: { parent: true, id: bid, count: b.count, total: b.total } }); placed[b.box.key] = 1;
        b.lines.forEach(function(ch){
          if(ch === b.box) return;
          out.push({ item: ch, sub: true, bundle: { child: true, id: bid } }); placed[ch.key] = 1;
        });
        return;
      }
      var par = it.properties && it.properties._c9_parent;
      if(par && byKey[par]) return;
      out.push({ item: it, sub: false }); placed[it.key] = 1;
      var k = it.properties && it.properties._c9_key;
      if(k) items.forEach(function(ch){ if(ch.properties && ch.properties._c9_parent === k){ out.push({ item: ch, sub: true }); placed[ch.key] = 1; } });
    });
    items.forEach(function(it){ if(!placed[it.key]) out.push({ item: it, sub: false }); });
    return out;
  }

  var CART = null;
  function render(cart){
    CART = cart;
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
    renderMeta(cart);
    var addonsEl = drawer.querySelector('[data-c9b-addons]');
    if(!cart.item_count){
      body.innerHTML = '<div class="c9b__empty"><b>' + esc(T.empty_title) + '</b><p>' + esc(T.empty_text) + '</p><a href="' + esc(T.empty_url) + '" class="c9b__btn c9b__btn--sm" rel="nofollow" data-close-cart>' + esc(T.empty_cta) + '</a>' + (T.empty_finder_url ? '<a href="' + esc(T.empty_finder_url) + '" class="c9b__finder" data-close-cart data-c9-track-surface="bag">' + esc(T.empty_finder) + '</a>' : '') + '</div>';
      if(foot) foot.hidden = true;
      return;
    }
    body.innerHTML = '<ul class="c9b__lines" role="list" data-cart-items>' + ordered(cart.items).map(function(o){ return lineHTML(o.item, o.sub, o.bundle); }).join('') + '</ul><div class="c9b__addons" data-c9b-addons hidden></div>';
    renderAddons();
    if(foot){
      foot.hidden = false;
      var sub = foot.querySelector('[data-cart-subtotal]'); if(sub) sub.textContent = fmt(cart.total_price);
      renderFootnote();
      var cl = foot.querySelector('[data-c9b-cta-label]'); if(cl) cl.textContent = T.cta;
      var nx = foot.querySelector('[data-c9b-next]'); if(nx){ nx.textContent = T.cta_note; nx.hidden = !T.cta_note; }
      renderExtras(cart);
      var wh = foot.querySelector('[data-c9b-when]');
      var date = cart.attributes && cart.attributes.Date;
      if(wh){
        if(date){
          var d = new Date(date + 'T00:00:00');
          var label = isNaN(d.getTime()) ? date : d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
          var slot = cart.attributes['Time slot'];
          wh.textContent = T.when.replace('{date}', label + (slot ? ', ' + slot : ''));
          wh.hidden = false;
        } else { wh.hidden = true; }
      }
    }
  }
  /* C2 (audit): free-delivery progress (DHA & Clifton, bike or car, from
     House rules), the payment line, a WhatsApp help link carrying the basket,
     and the discount-code note. All text is computed or from House rules. */
  function renderExtras(cart){
    var ex = drawer.querySelector('[data-c9b-extras]');
    if(!ex) return;
    var thr = +RULES.free_delivery_threshold || 0, zones = RULES.free_zones || 'DHA & Clifton';
    var bar = '';
    if(thr > 0){
      var left = thr - cart.total_price, pct = Math.max(0, Math.min(100, Math.round(cart.total_price / thr * 100)));
      var line = left > 0
        ? fmt(left) + ' more for free delivery in ' + zones
        : 'Free delivery in ' + zones + ' unlocked';
      bar = '<div class="c9b-free" role="status"><div class="c9b-free__bar"><span style="width:' + pct + '%"></span></div><p class="c9b-free__t">' + esc(line) + '</p></div>';
    }
    var wa = RULES.phone_wa ? 'https://wa.me/' + RULES.phone_wa + '?text=' + encodeURIComponent('Hi Coco 9, a question about my bag: ' + cart.items.map(function(i){ return i.quantity + '× ' + i.product_title; }).join(', ') + ' (' + fmt(cart.total_price) + ')') : '';
    ex.innerHTML = bar +
      '<ul class="c9b-assure" role="list"><li>Pay by cash on delivery, bank transfer or card</li><li>Have a code? Add it at checkout</li>' +
      (wa ? '<li><a href="' + esc(wa) + '" target="_blank" rel="noopener" data-c9-track-surface="bag">Questions? WhatsApp ' + esc(RULES.phone_display || '') + '</a></li>' : '') + '</ul>';
  }
  function refresh(){ return getCart().then(render).catch(function(){}); }

  /* ── qty / remove (/cart/change.js by line key; parent removal takes its linked lines) ── */
  function busy(key){ var li = body.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]'); if(li) li.setAttribute('aria-busy', 'true'); }
  body.addEventListener('click', function(e){
    var grp = e.target.closest('[data-c9b-rm-group]');
    if(grp && CART){
      var gid = grp.getAttribute('data-c9b-rm-group');
      var gup = {};
      CART.items.forEach(function(i){ if(i.properties && i.properties._c9_box_id === gid) gup[i.key] = 0; });
      grp.disabled = true;
      var li = grp.closest('li'); if(li) li.setAttribute('aria-busy', 'true');
      postJSON('/cart/update.js', { updates: gup }).then(function(){ return refresh(); }).catch(function(){ refresh(); });
      return;
    }
    var inc = e.target.closest('[data-c9b-inc]'), dec = e.target.closest('[data-c9b-dec]'), rm = e.target.closest('[data-c9b-rm]');
    var key = inc ? inc.getAttribute('data-c9b-inc') : dec ? dec.getAttribute('data-c9b-dec') : rm ? rm.getAttribute('data-c9b-rm') : null;
    if(!key || !CART) return;
    var item = CART.items.filter(function(i){ return i.key === key; })[0];
    if(!item) return refresh();
    busy(key);
    var req;
    if(rm){
      var updates = {}; updates[key] = 0;
      var own = item.properties && item.properties._c9_key;
      if(own) CART.items.forEach(function(ch){ if(ch.properties && ch.properties._c9_parent === own) updates[ch.key] = 0; });
      req = postJSON('/cart/update.js', { updates: updates });
    } else {
      req = postJSON('/cart/change.js', { id: key, quantity: Math.max(0, item.quantity + (inc ? 1 : -1)) });
    }
    req.then(function(){ return refresh(); }).catch(function(){ refresh(); });
  });

  /* ── "Finish the gift" add-ons + copy, from the Cart template ── */
  var cfgLoading = null;
  function applyConfig(cfg){
    if(!cfg) return;
    if(cfg.copy) Object.keys(cfg.copy).forEach(function(k){ if(cfg.copy[k] !== '' && cfg.copy[k] != null) T[k] = cfg.copy[k]; });
    ADDONS = cfg.addons || [];
  }
  function readConfig(doc){
    var el = doc.querySelector('[data-c9b-config]');
    if(!el) return null;
    try { return JSON.parse(el.textContent); } catch(_) { return null; }
  }
  function loadConfig(){
    if(cfgLoading) return cfgLoading;
    var local = readConfig(document);
    if(local){ applyConfig(local); cfgLoading = Promise.resolve(); if(CART) render(CART); return cfgLoading; }
    try {
      var c = JSON.parse(sessionStorage.getItem('c9b-config-v1') || 'null');
      if(c && Date.now() - c.t < 30 * 60 * 1000){ applyConfig(c.v); cfgLoading = Promise.resolve(); if(CART) render(CART); return cfgLoading; }
    } catch(_) {}
    cfgLoading = fetch(CART_URL, { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var cfg = readConfig(new DOMParser().parseFromString(html, 'text/html'));
        if(!cfg) return;
        applyConfig(cfg);
        try { sessionStorage.setItem('c9b-config-v1', JSON.stringify({ t: Date.now(), v: cfg })); } catch(_) {}
        if(CART) render(CART);
      })
      .catch(function(){});
    return cfgLoading;
  }
  function renderAddons(){
    var el = body.querySelector('[data-c9b-addons]');
    if(!el || !CART) return;
    var inBag = {}; CART.items.forEach(function(i){ inBag[i.variant_id] = 1; });
    var list = ADDONS.filter(function(a){ return a && a.id && a.available && !inBag[a.id]; }).slice(0, 4);
    if(!list.length){ el.hidden = true; el.innerHTML = ''; return; }
    el.innerHTML = '<h3>' + esc(T.addons_title) + '</h3>' + list.map(function(a){
      return '<button type="button" class="c9b-ao" data-c9b-ao="' + a.id + '" aria-label="Add ' + esc(a.name) + ', ' + fmt(a.price) + '">' +
        '<span class="c9b-ao__i">' + (a.image ? '<img src="' + esc(a.image) + '" alt="" loading="lazy" width="44" height="44">' : '') + '</span>' +
        '<span class="c9b-ao__t"><b>' + esc(a.name) + '</b><small>' + esc(a.note || T.addons_note) + '</small></span>' +
        '<span class="c9b-ao__p">' + fmt(a.price) + '</span><span class="c9b-ao__add" aria-hidden="true">Add</span></button>';
    }).join('');
    el.hidden = false;
  }
  body.addEventListener('click', function(e){
    var b = e.target.closest('[data-c9b-ao]');
    if(!b || b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    postJSON('/cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-c9b-ao'), 10), quantity: 1 }] })
      .then(function(){ return refresh(); })
      .catch(function(err){ b.removeAttribute('aria-busy'); alert(err.message || 'Could not add that. Please try again.'); });
  });

  /* ── product forms: add to bag (with linked card / add-on lines), then slide in ── */
  function formItems(form){
    var fd = new FormData(form), main = { id: 0, quantity: 1, properties: {} };
    fd.forEach(function(v, k){
      if(k === 'id') main.id = parseInt(v, 10);
      else if(k === 'quantity') main.quantity = Math.max(1, parseInt(v, 10) || 1);
      else { var m = /^properties\[(.+)\]$/.exec(k); if(m && String(v) !== '') main.properties[m[1]] = String(v); }
    });
    var linked = [];
    var le = form.querySelector('[data-c9-linked]');
    if(le){ try { linked = JSON.parse(le.value || '[]') || []; } catch(_) { linked = []; } }
    if(!linked.length) return null;
    var key = 'c9' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var title = form.getAttribute('data-product-title') || '';
    main.properties._c9_key = key;
    var items = [main];
    linked.forEach(function(l){
      if(!l || !l.id) return;
      var props = { _c9_parent: key };
      props[l.role === 'card' ? 'Card for' : 'Add-on for'] = title;
      items.push({ id: l.id, quantity: 1, properties: props });
    });
    return { items: items };
  }
  document.addEventListener('submit', function(e){
    var form = e.target.closest && e.target.closest('form[data-add-to-cart-form]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-pdp-err]');
    var origLabel = btn && btn.innerHTML;
    if(btn){ btn.disabled = true; btn.innerHTML = 'Adding…'; }
    if(err && /add|bag|stock|available/i.test(err.textContent)) err.hidden = true;
    var json = formItems(form);
    var req = json
      ? postJSON('/cart/add.js', json)
      : fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description || j.message || 'Could not add to bag.'); return j; }); });
    req.then(function(){ return getCart(); })
      .then(function(cart){
        render(cart);
        openCart();
        document.dispatchEvent(new CustomEvent('c9:cart:added', { detail: { form: form, cart: cart } }));
      })
      .catch(function(x){
        var msg = (x && x.message) || 'Could not add to bag. Please try again.';
        if(err){ err.textContent = msg; err.hidden = false; err.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else { alert(msg); }
      })
      .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = origLabel; } });
  });

  window.C9Cart = { open: function(){ refresh(); openCart(); }, close: closeCart, refresh: refresh };
})();
